/// <reference path="../../node_modules/@types/bootstrap/index.d.ts" />
var hasEmailInstructionModal: boolean

/* eslint-disable-next-line */
var apt: any = apt || {};
apt.sm = (function ($: JQueryStatic) {
	const _webId: string = $("#WebID").val() as string;

	function _getNodeNumber(): number { return $("#NodeNumber").val() as number; }

	function _checkboxNAhandling(checkbox: JQuery<HTMLElement>, noneOptionId: string) {
		if (checkbox.is(":checked")) { //if cb isn't checked, carry on
			//check/uncheck based on selection
			if (noneOptionId === checkbox.prop("id")) //none checked - clear others
			{
				$(":checkbox[name='" + checkbox.prop("name") + "']").each(function () {
					if ($(this).prop("id") !== noneOptionId) { $(this).prop("checked", false); }
				});
			}
			else if (noneOptionId === "undefined" || noneOptionId === "") { /* N/A response option not on the page, do nothing */ }
			else // something's checked besides none - clear none checkbox
			{
				$("#" + noneOptionId).prop("checked", false);
			}
			checkbox.parent().addClass("focus active");
		}
		else {
			checkbox.removeClass("focus active");
			checkbox.parent().removeClass("focus active");
		}
	};

	/**
	* document-level event handling
	*/
	$(document)
		/* Allow response option text to select the ro */
		.on("click", "[data-item='ro'], [data-item='ro-horizontal']", function () {
			const btn = $(this).find('.btn-ro')
			const groupName = $(this).data('name')
			const group = $(`div [data-name="${groupName}"]`)
			const inputs = group.find("input")
			const selected = $(this).find(".item-ro")

			group.removeClass('active')
			inputs.removeAttr('checked')
			selected.attr("checked", "checked")
				.parent().button("toggle")

			btn.addClass("active")
		})
		.on("click", "[data-item='ratings']", function () {
			const ro = $(this).find('label')
			const group = ro.data('name')
			$(`[data-name="${group}"]`)
				.removeClass('active')
				.find('input')
				.removeAttr('checked')

			const input = $(this).find("input")
			$(input).attr("checked", "checked")
				.parent()
				.button("toggle")
				.addClass("active")
		})
		.on("click", "[data-item='chk']", function () {
			const btn = $(this)
			const chk = btn.find(".item-ro")
			const isChecked = chk.is(":checked")

			chk.prop("checked", !isChecked)
			_checkboxNAhandling(chk, chk.data("noneoption"));
		})
		/* Prevent form submission when pressing the Enter key in a textbox */
		.on("keydown", ".no-submit", e => {
			if (e.key === 'Enter') e.preventDefault();
		})
		/* Get temp background filepath if selected */
		.on("change", ".selectTempBackground", e => {
			_setTempBodyBackground(e.target.files[0]);
		})
		.on('submit', '[data-ajax-animate]', () => {
			$('#surveyContainer').fadeOut(500)
		})

	$(function () {
		/* check for required bootstrap script */
		if (!$.fn.modal && window.location.href.indexOf("Exit") < 0)
			window.location.href = siteUrl.concat("/Logon/Exit?ScriptError");
		$("[data-toggle='tooltip']").tooltip();
		$("[data-bs-toggle='tooltip']").tooltip();

		_setupPage(document.body.innerHTML);

		if (aptUtils.prefersReducedMotion) {
			$('#chkAnimationEnabled').addClass('bi-x-circle text-danger')
			$('#chkAnimationEnabled').removeClass('bi-check-circle text-success')
		}

		history.pushState(null, document.title, location.href);
		window.addEventListener("popstate", function () {
			history.pushState(null, document.title, location.href);
		});
	});

	function _setLanguage() {
		$("html")
			.prop("lang", $("#langCode").val())
			.prop("dir", $("#langRtl").val());
	}

	function _populateItems() {
		$("input:radio").each(function () {
			const rating = $(this);
			if (rating.prop("checked")) {
				rating.trigger("click").parent().addClass("active");
			}
		});
	}

	/**
	 * Remove a stylesheet
	 * @param {string} styleID The stylesheet ID
	 */
	function _clearStyle(styleID: string) {
		$("#" + styleID).prop('disabled', true);
		$("#" + styleID).remove();
	}

	/**
	 * Manage a stylesheet
	 * @param {string} styleID The stylesheet ID
	 * @param {string} fileName The CSS file with action, may be "" (none/remove), "+style1.css" (replace with new) or "style1.css" (same if exists)
	 */
	function _initStyle(styleID: string, fileName: string) {
		let found = false;
		if ($("#" + styleID).length) { /* Styles defined */
			if (!fileName || fileName[0] === "+") { _clearStyle(styleID); }
			else { found = true; }
		}
		if (fileName && !found) {
			$("head").append('<link id="' + styleID + '" rel="stylesheet" type="text/css" href="' + siteUrl + fileName.replace("+", "").replace("~", "") + '">');
		}
	}

	/**
	 * Stylesheet setup at test battery (tb), test (tt) and item group (ig) levels.
	 */
	function _initStyles() {
		if ($("#Styles")) {
			_initStyle("stb", $("#Styles").data("1"));
			_initStyle("stt", $("#Styles").data("2"));
			_initStyle("sig", $("#Styles").data("3"));
		}
	}

	/** Initialize the page. Execute functions on ajax.onSuccess and document.ready
	* @memberof apt.sm
	* @param {any} data On initial page load, the document. On ajax callback, any data from server 
	*/
	function _setupPage(data: any) {
		$('form:not(#interaction)').parent()
			.addClass('form-animate')

			$('#surveyContainer').fadeIn(1000).css('display', 'flex')

		if (data.length > 0) {
			if (data.indexOf("data-type=\"item\"") > 0) _populateItems();
			if (data.indexOf("data-validation") > 0) aptValidation.init();
			if (data.indexOf("<video") > 0 || data.indexOf("<audio") > 0) aptMedia.init();
			if (data.indexOf("data-type=\"hub\"") > 0 || data.indexOf("id=\"hub\"") > 0) aptHub.init();
			if (data.indexOf("data-type=\"rankOrderDnD\"") > 0) apt.dragDrop.init();
			if (data.indexOf("img-heatmap") > 0) aptImageMap.init();
			if (data.indexOf(`id="interaction"`) > 0) _initPortalInteraction();
			if (data.indexOf(`id="voiceoverWrapper"`) > 0) _initNarrator();
			if (data.indexOf(`instruction-container inbox-form`) > 0) _initInstructionEmail()
			if (data.indexOf(`id="textareaSpeechRecord"`) > 0) aptSpeechServices.init();
			if (data.indexOf("data-type=\"aiChat\"") > 0) aptChat.init();

			_initStyles();
			_setLanguage();

			// Hide the top nav menu if the page has a menu-type resource bar, show the menu if the page has a default or no resource bar
			document.getElementById("topResourceBar") !== null && !document.getElementById("topResourceBar")?.classList.contains("resource-bar-default") ? $("#navbarDropdownMenuLink").hide() : $("#navbarDropdownMenuLink").show();

			// Move the small form-factor side-nav buttons inside survey container
			$('.side-nav-sm').appendTo('.survey-form')
		}
	}

	function _initPortalInteraction() {
		$('#interaction').parent().removeClass('form-animate')

		if ($('#interaction').find('#media').length > 0) { $('#interactionNav').removeClass('container').insertAfter('#video') }
		else if ($('#interaction .voiceover').length > 0) { $('#interactionNav').appendTo('#bottomNavPlaceholder') }
		else if ($('#interaction .landing-container').length > 0) { $('#interactionNav').addClass('fixed-bottom px-2').removeClass('container') }
		else $('#interactionNav').insertAfter('#interaction .interaction-text-container')

		if ($('.interaction-text-container').find('.portal-inner-content').length > 0 && $('.portal-privacy-statement').length < 1) {
			$('.interaction-text-container').addClass('d-flex px-0').removeClass('px-5 py-4')
			$('.portal-inner-content').addClass('p-3')
			$('#previous').insertBefore('.portal-inner-content')
			$('#next').insertAfter('.portal-inner-content')
			$('.side-nav-sm').appendTo('#interactionNav')
			$('#interactionNav').appendTo('#bottomNavPlaceholder').insertAfter('.interaction-text-container')
		}
	}

	function _initNarrator() {
		const narrator = $('.instruction-container .voiceover')
		if (narrator.find('audio').length > 0 || narrator.find('#narrator').length > 0) {
			$('#bottomNavPlaceholder').addClass('mt-2 me-0 ms-auto').append($('#navButtons'))
		}
	}

	function _initInstructionEmail() {
		if (!hasEmailInstructionModal) return

		const smModal = $('#sm-modal-dialog')
		const smModalDialog = $('#sm-modal-dialog .modal-dialog')
		const surveyContainer = $('#surveyContainer')

		smModal.attr('data-bs-backdrop', 'static').attr('data-bs-keyboard', 'false')
		smModalDialog
			.addClass('modal-lg modal-fullscreen-md-down modal-dialog-centered modal-dialog-scrollable')
			.find('.modal-body').addClass('d-flex py-0')

		//$("#sm-modal-dialog").one("shown.bs.modal", () => { $('#next').trigger('click') })
		smModal.one("hidden.bs.modal", () => {
			surveyContainer.fadeOut()
			$('#next').trigger('click')
		})

		aptUtils.showModalDialog('', surveyContainer.clone())
		$('#smModalTitle').append($('.modal-body .preview-pane-header.sender'))
		surveyContainer.hide()

		smModal.on("hidden.bs.modal", () => {
			smModalDialog
				.removeClass('modal-lg modal-fullscreen-md-down modal-dialog-centered modal-dialog-scrollable')
				.find('.modal-body').removeClass('d-flex py-0')
		})
	}

	function _setTempBodyBackground(file: File) {

		const formData = new FormData();
		formData.append(file.name, file);

		aptAjax.request({
			url: "SetTempBodyBackground",
			data: formData,
			contentType: false,
			processData: false,
			done: function (data: any) {
				if (data.success) { window.location.reload(); }
				else { (alert(data.message)); }
			},
			fail: function (jqXHR: JQuery.jqXHR, textStatus: JQuery.Ajax.ErrorTextStatus | null, errorThrown: string) {
				alert("An internal error has occurred.");
			}
		});

	}

	return {
		checkboxNAhandling: _checkboxNAhandling,
		populateItems: _populateItems,
		webId: _webId,
		getNodeNumber: _getNodeNumber,
		initStyles: _initStyles,
		setupPage: _setupPage,
		initPortalInteraction: _initPortalInteraction
	}
})($);

/* Review Responses */
apt.rr = (function ($: JQueryStatic) {
	function _showUnanswered(allQuestionsAnswered: string) {
		$(".answered").hide();
		$("#allAnsweredText").show();
		if (allQuestionsAnswered === "True") $("#rrItems").hide();
	}

	function _showAll() {
		$(".answered").show();
		$("#allAnsweredText").hide();
		$("#rrItems").show();
	}

	function _confirmSubmit(OKText: string, cancelText: string) {
		let submitText = '';
		if ($(".unanswered").length > 0)
			submitText = $("#submitUnanswered").val() as string;
		else
			submitText = $("#submitAllAnswered").val() as string;
		const submit = function () { $("#survey").attr("action", "Next").submit(); };
		aptUtils.confirmationModal("", submitText, submit, OKText, cancelText);
	}

	return {
		showUnanswered: _showUnanswered,
		showAll: _showAll,
		confirmSubmit: _confirmSubmit
	}
})($);